import { render, staticRenderFns } from "./BloqueForm.vue?vue&type=template&id=11a53669"
import script from "./BloqueForm.vue?vue&type=script&lang=js"
export * from "./BloqueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports